import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";

const MoreInfo = () => {
  const navigate = useNavigate();
  const [nshow, setNshow] = useState(true);

  useEffect(() => {
  
  }, []);
  return (
    <div id="mainpage">
      <div className="maincontent">
        {/* <div className="dash-head">
          <Row className="row-sm">
            <div className="col-12 text-left">
              <h4 className="nidjamhead-title">More Information</h4>
            </div>
          </Row>
        </div> */}
        <hr className="mb-0" />

        <div className="moreone">
          <div className="morelogo">
            <img
              src={require("../assets/images/logo/tracking-logo.png")}
              alt="dash-logo"
            />
          </div>

          <div className="morecontent">
            <h4 className="morehead-title">More Information</h4>

            <div className="morelinks-sections">
              <Link to={"/aboutschool"} className="morelinks">
                <h4>
                  About School <i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link>
              {/* <Link to={"/district"} className="morelinks">
                <h4>
                  Past Events <i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link>

              <Link to={"/watchlive"} className="morelinks">
                <h4>
                  Watch Live <i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link>
              <Link to={"/moregallery"} className="morelinks">
                <h4>
                  Photo &amp; Video Gallery{" "}
                  <i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link> */}
              {nshow && (
                <Link to={"/notification"} className="morelinks">
                  <h4>
                    Notification{" "}
                    <i className="fa-solid fa-arrow-turn-right"></i>
                  </h4>
                </Link>
              )}
              {/* <Link to={"/timetable"} className="morelinks">
                <h4>
                  Time Table<i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link> */}
              {/* <Link to={"/logout"} className="morelinks">
                <h4>
                  Reset Password <i className="fa-solid fa-arrow-turn-right"></i>
                </h4>
              </Link> */}
              <a
                onClick={() => {
                  localStorage.clear();
                  navigate("/login");
                }}
                className="morelinks"
              >
                  <h4>
                    Logout  <i className="fa-solid fa-arrow-turn-right"></i>
                  </h4>
              
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MoreInfo;
